import { faCheckCircle, faClock, faLink, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover } from "antd";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import FileIcon from "react-file-icon";
import { labels } from "../../../../../localization/labels";
import { messages } from "../../../../../localization/messages";
import { constants } from "../../../../../utils/Constants";
import BasicDialog from "../../../../core/BasicDialog/BasicDialog";
import ChoicePopUp from "../../../../core/ChoicePopUp";
import FileUploader from "../../../../core/FileUploader";
import SubmitButton from "../../../../core/SubmitButton";
import Table from "../../../../core/Table";
import TableFormatter from "../../../../core/Table/TableUtils";
import SimilarDocuments from "./SimilarDocuments";

export const getSearchableIcon = cellContent => {
  if (!cellContent) return null;

  switch (cellContent.name) {
    case constants.SEARCHABLE_STATUS.SEARCHABLE:
      return <FontAwesomeIcon size="lg" color="green" icon={faCheckCircle}/>;
    case constants.SEARCHABLE_STATUS.NONSEARCHABLE:
      return <FontAwesomeIcon size="lg" color="red" icon={faTimesCircle}/>;
    case constants.SEARCHABLE_STATUS.INDEXING:
      return <FontAwesomeIcon size="lg" color="orange" icon={faClock}/>;
    default:
      return null;
  }
};

const getDocumentTableColumns = (
  showCheck,
  onEditClick,
  onDocumentDownload,
  onSimilarClick,
  editable
) => {
  return [
    {
      dataField: "name",
      text: labels.name,
      formatter: TableFormatter.textFormatter
    },
    {
      dataField: "description",
      text: labels.description,
      formatter: TableFormatter.textFormatter
    },
    {
      dataField: "recordedTimeStamp",
      text: labels.dateCreated,
      formatter: TableFormatter.dateFormatter
    },
    {
      dataField: "contentType",
      headerClasses: "column-id",
      text: labels.contentType,
      formatter: (cellContent, row) => {
        if (row.documentType === constants.DOCUMENT_TYPE.FILE.id) {
          return (
            <div className="column-id">
              <FileIcon size="30" extension={row.extension.id}/>
            </div>
          );
        } else {
          return (
            <div className="column-id">
                <FontAwesomeIcon size="lg" color="#007bff" icon={faLink} />
            </div>
          );
        }
      }
    },
    {
      dataField: "searchableStatus",
      headerClasses: "column-id",
      text: labels.searchable,
      formatter: (cellContent, row) => (
        <Popover
          content={cellContent ? messages[cellContent.label] : undefined}
          placement="topLeft"
        >
          <div className="column-id">{getSearchableIcon(cellContent)}</div>
        </Popover>
      )
    },
    {
      dataField: "df1",
      isDummyField: true,
      headerClasses: "column-id",
      text: labels.actions,
      formatter: (cellContent, row) => {
        return (
          <div className="column-id">
            {editable ? (
              <Button
                className="fa fa-trash buttonStyle"
                title={labels.deleteButton}
                size="sm"
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  document = row;
                  showCheck();
                }}
              />
            ) : null}
            {editable ? (
              <Button
                className="fa fa-edit buttonStyle"
                size="sm"
                title={labels.edit}
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  onEditClick(row);
                }}
              />
            ) : null}
            {onSimilarClick ? (
              <Button
                className="fa fa-bars buttonStyle"
                size="sm"
                title={labels.showSimilarDocuments}
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  onSimilarClick(row);
                }}
              />
            ) : null}
            <Button
              className="fa fa-cloud-download buttonStyle"
              size="sm"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onDocumentDownload(row);
              }}
            />
          </div>
        );
      }
    }
  ];
};

var document = undefined;

const Document = ({
                    documents,
                    onEditClick,
                    onDocumentDownload,
                    onDocumentsUpload,
                    onDocumentDelete,
                    fileUploaderRef,
                    documentForUpload,
                    onDocumentSelect,
                    onChange,
                    showUploader,
                    handleShowUploader,
                    handleCloseUploader,
                    disabled,
                    disabledUpdateDocument,
                    validationRules,
                    paginationOptions,
                    handleTableChange,
                    maxLength,
                    onSave,
                    selectedDocument,
                    onRowClick,
                    onDocumentEditChange,
                    showEditDialog,
                    handleCloseEditDialog,
                    editable,
                    setSelected,
                    hideCreateForm,
                    onShowSimilarDocuments,
                    showSimilarDocuments,
                    handleCloseSimilarDocuments,
                    messageHandler,
                    breadcrumbsHandler,
                    documentTypes
                  }) => {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const choices =
    document === undefined
      ? []
      : [
        { label: labels.no, onClick: handleClose },
        {
          label: labels.yes,
          onClick: () => {
            onDocumentDelete(document);
          }
        }
      ];

  const inputFieldsForLink = () => {
    const inputFields = [
      {
        label: labels.documentLinkPreview,
        controlId: "previewUrl",
        placeholder: labels.documentLinkPreview
      },
      {
        label: labels.documentLinkDownload,
        controlId: "downloadUrl",
        placeholder: labels.documentLinkDownload,
      },
      {
        label: labels.documentLinkDuration,
        controlId: "duration",
        placeholder: labels.documentLinkDuration,
        type: "number"
      },
      {
        label: labels.documentLinkSize,
        controlId: "size",
        placeholder: labels.documentLinkSize,
        type: "number"
      }
    ];
    return inputFields;
  };

  return (
    <>
      {documents && (
        <div className="UploadTableTab">
          {editable && !hideCreateForm ? (
            <Row>
              <Col className="tableButtons right-text-div">
                <SubmitButton type="upload" onClick={handleShowUploader}/>
              </Col>
            </Row>
          ) : editable && hideCreateForm ? (
            <FileUploader
              multiple={false}
              onUpload={onDocumentsUpload}
              ref={fileUploaderRef}
              disabled={disabled}
              hideButtonAndBar={hideCreateForm}
              onSelect={onDocumentSelect}
            />
          ) : null}
          {!hideCreateForm ? (
            <>
              <Table
                data={documents}
                columns={getDocumentTableColumns(
                  handleShow,
                  onEditClick,
                  onDocumentDownload,
                  onShowSimilarDocuments,
                  editable
                )}
                paginationOptions={paginationOptions}
                onTableChange={handleTableChange}
                onRowClick={onRowClick}
              />
              <ChoicePopUp
                title={labels.areYouSureDelete}
                choices={choices}
                show={show}
                handleClose={handleClose}
              />
              <BasicDialog
                dialogTitle={labels.documentsUpdate}
                show={showEditDialog}
                entity={selectedDocument}
                maxLength={maxLength}
                onSave={onSave}
                onChange={onDocumentEditChange}
                disabled={disabledUpdateDocument}
                validationRules={validationRules}
                handleClose={handleCloseEditDialog}
                additionalInputFields={selectedDocument?.documentType?.id === constants.DOCUMENT_TYPE.LINK.id ? inputFieldsForLink() : ""}
                documentTypes={documentTypes}
                selectedDocumentType={selectedDocument?.documentType?.id}
              />
              <BasicDialog
                submitType="fileUploader"
                dialogTitle={labels.documentEntryForm}
                show={showUploader}
                entity={documentForUpload}
                maxLength={maxLength}
                validationRules={validationRules}
                handleClose={handleCloseUploader}
                onDocumentsUpload={onDocumentsUpload}
                disabled={disabled}
                fileUploaderRef={fileUploaderRef}
                onChange={onChange}
                onDocumentSelect={onDocumentSelect}
                setSelected={setSelected}
                additionalInputFields={documentForUpload?.documentType?.id === constants.DOCUMENT_TYPE.LINK.id ? inputFieldsForLink() : ""}
                documentTypes={documentTypes}
                selectedDocumentType={documentForUpload?.documentType?.id}
              />
              <BasicDialog
                dialogTitle={labels.similarDocuments}
                show={showSimilarDocuments.showModal}
                handleClose={handleCloseSimilarDocuments}
                entity={{
                  noName: true,
                  noDescription: true,
                  noDateRange: true
                }}
                size="xl"
              >
                <SimilarDocuments
                  messageHandler={messageHandler}
                  breadcrumbsHandler={breadcrumbsHandler}
                  document={showSimilarDocuments.document}
                />
              </BasicDialog>
            </>
          ) : null}
        </div>
      )}
    </>
  );
}

export default Document;
